<template>
  <div
    v-if="showLoadingState < 4"
    key="loadingState"
  >
    <AtomLoadingSecondary/>
  </div>
  <div
    v-else
    key="accountProfile"
  >
    <div class="m-edition-billing-my-payments-billing-data">
      <form
        autocomplete="off"
        @submit.prevent="updateClient"
      >
        <div class="m-container-primary">
          <div class="row">
            <div class="column column-3">
              <AtomSelectPrimaryTimeout
                v-model.number="cliente.pais"
                :elements="paises"
                :input-error="$v.cliente.pais.$error"
                key-field="id_pais"
                :label="$t('mEditionBillingMyPaymentsBillingData.inputs.pais.label')"
                :message-error="messageErrorPais"
                name="pais"
                reference="pais"
                text-field="nombre"
                @blur="$v.cliente.pais.$touch()"
                @input="readParametroDocumentoTipos($event); readParametroProvincias($event)"
                :disabled="facturaArgentina"
              />
            </div>

            <div class="column column-3">
              <AtomSelectPrimary
                v-model.number="cliente.provincia"
                :elements="provincias"
                :input-error="$v.cliente.provincia.$error"
                key-field="id_provincia"
                :label="$t('mEditionBillingMyPaymentsBillingData.inputs.provincia.label')"
                :message-error="messageErrorProvincia"
                name="provincia"
                reference="provincia"
                text-field="nombre"
                @blur="$v.cliente.provincia.$touch()"
              />
            </div>

            <div class="column column-4">
              <AtomInputPrimary
                v-model="cliente.localidad"
                :input-error="$v.cliente.localidad.$error"
                :label="$t('mEditionBillingMyPaymentsBillingData.inputs.localidad.label')"
                :message-error="messageErrorLocalidad"
                name="localidad"
                reference="localidad"
                type="text"
                @blur="$v.cliente.localidad.$touch()"
              />
            </div>
          </div>

          <div class="row">
            <div class="column column-2">
              <AtomInputPrimary
                v-model="cliente.cod_postal"
                :input-error="$v.cliente.cod_postal.$error"
                :label="$t('mEditionBillingMyPaymentsBillingData.inputs.cod_postal.label')"
                :message-error="messageErrorCodigoPostal"
                name="cod_postal"
                reference="cod_postal"
                type="text"
                @blur="$v.cliente.cod_postal.$touch()"
              />
            </div>

            <div class="column column-4">
              <AtomInputPrimary
                v-model="cliente.linea1"
                :input-error="$v.cliente.linea1.$error"
                :label="$t('mEditionBillingMyPaymentsBillingData.inputs.linea1.label')"
                :message-error="messageErrorlinea1"
                name="linea1"
                reference="linea1"
                type="text"
                @blur="$v.cliente.linea1.$touch()"
              />
            </div>

            <div class="column column-4">
              <AtomInputPrimary
                v-model="cliente.linea2"
                :label="$t('mEditionBillingMyPaymentsBillingData.inputs.linea2.label')"
                name="linea2"
                type="text"
              />
            </div>
          </div>

          <div class="row">
            <div class="column column-3">
              <AtomSelectPrimary
                v-model.number="cliente.fisica"
                :elements="$filters.parameters.persons"
                :input-error="$v.cliente.fisica.$error"
                key-field="id"
                :label="$t('mEditionBillingMyPaymentsBillingData.inputs.fisica.label')"
                :message-error="messageErrorFisica"
                name="fisica"
                reference="fisica"
                text-field="name"
                @blur="$v.cliente.fisica.$touch()"
                :disabled="facturaTipoComputada === 'FA'"
              />
            </div>

            <div class="column column-7">
              <AtomInputPrimary
                v-model="cliente.razon_social"
                :input-error="$v.cliente.razon_social.$error"
                :label="cliente.fisica === 0
                ? $t('mEditionBillingMyPaymentsBillingData.inputs.razon_social.labelBusiness')
                : $t('mEditionBillingMyPaymentsBillingData.inputs.razon_social.labelName')"
                :message="$t('mEditionBillingMyPaymentsBillingData.inputs.razon_social.message')"
                :message-error="messageErrorRazonSocial"
                name="razon_social"
                reference="razon_social"
                type="text"
                @blur="$v.cliente.razon_social.$touch()"
              />
            </div>
          </div>

          <div class="row">
            <div class="column column-3">
              <AtomSelectPrimary
                v-model.number="cliente.documento_tipo"
                :elements="documentoTipos"
                :input-error="$v.cliente.documento_tipo.$error"
                key-field="id_documento_tipo"
                :label="$t('mEditionBillingMyPaymentsBillingData.inputs.documento_tipo.label')"
                :message-error="messageErrorTipoDoc"
                name="documento_tipo"
                reference="documento_tipo"
                text-field="nombre"
                @blur="$v.cliente.documento_tipo.$touch()"
                :disabled="facturaTipoComputada === 'FA'"
              />
            </div>

            <div class="column column-7">
              <AtomInputPrimary
                v-model="cliente.documento_numero"
                :input-error="$v.cliente.documento_numero.$error"
                :label="$t('mEditionBillingMyPaymentsBillingData.inputs.documento_numero.label')"
                :message="$t('mEditionBillingMyPaymentsBillingData.inputs.documento_numero.message')"
                :message-error="messageErrorDocumentoNum"
                name="documento_numero"
                reference="documento_numero"
                type="text"
                @blur="$v.cliente.documento_numero.$touch()"
              />
            </div>
          </div>

          <div class="row">
            <div class="column column-5">
              <AtomInputPrimary
                v-model="cliente.telefono"
                :input-error="$v.cliente.telefono.$error"
                :label="$t('mEditionBillingMyPaymentsBillingData.inputs.telefono.label')"
                :message-error="messageErrorTelefono"
                name="telefono"
                reference="telefono"
                type="text"
                @blur="$v.cliente.telefono.$touch()"
              />
            </div>

            <div class="column column-5">
              <AtomInputPrimary
                v-model="cliente.movil"
                :input-error="$v.cliente.movil.$error"
                :label="$t('mEditionBillingMyPaymentsBillingData.inputs.movil.label')"
                :message-error="messageErrorMovil"
                name="movil"
                reference="movil"
                type="text"
                @blur="$v.cliente.movil.$touch()"
              />
            </div>
          </div>

          <div class="row">
            <div class="column column-5">
              <label
                v-if="facturaArgentina"
                class="display-flex-row a-checkbox-primary a-checkbox-billing-primary">
                <input
                  v-model="necesitaFactura"
                  class="a-checkbox-primary a-checkbox-input-billing-primary"
                  name="necesitaFactura"
                  type="checkbox"
                  :checked="cliente.factura_tipo === 'FA'"
                />
                <span class="a-checkbox-checkmark"></span>
                <span class="margin-left-small">
                  {{ $t('mEditionBillingMyPaymentsBillingData.checkFactura') }}
                </span>
              </label>
            </div>
          </div>

          <div class="row">
            <div class="column column-10">
              <AtomButtonPrimary :button-primary="buttonPrimary"/>
              <AtomButtonSecondary
                v-if="false"
                :button-secondary="buttonSecondary.reset"
              />
            </div>
          </div>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import { maxLength, minLength, required, requiredIf } from 'vuelidate/lib/validators'

export default {
  name: 'MoleculeEditionBillingMyPaymentsBillingData',

  data () {
    return {
      buttonPrimary: {
        action: 'Guardar',
        class: 'margin-right-medium margin-top-large',
        sending: false,
        type: 'submit'
      },

      buttonSecondary: {
        reset: {
          class: 'a-button-reset-secondary',
          component: '',
          icon: '',
          method: '',
          text: this.$t('aButtonSecondary.actions.reset'),
          type: 'reset'
        }
      },

      date: {
        day: '',
        month: '',
        year: ''
      },

      documentoTipos: [],

      necesitaFactura: false,

      paises: [],

      provincias: [],
      showLoadingState: 0,

      client: null,

      cliente: {
        cod_postal: '',
        documento_numero: '',
        documento_tipo: '',
        email: '',
        factura_tipo: '',
        fecha_creacion: '',
        fisica: 1,
        linea1: '',
        linea2: '',
        localidad: '',
        movil: '',
        pais: '',
        provincia: '',
        razon_social: '',
        telefono: ''
      }
    }
  },

  validations: {
    cliente: {
      cod_postal: {
        required
      },

      documento_numero: {
        maxLength: maxLength(30),
        minLength: minLength(3),
        required
      },

      documento_tipo: {
        required
      },

      fisica: {
        required
      },

      linea1: {
        required
      },

      localidad: {
        required
      },

      movil: {
        requiredIf: requiredIf(function () {
          return !this.cliente.telefono
        })
      },

      pais: {
        required
      },

      provincia: {
        required
      },

      razon_social: {
        maxLength: maxLength(150),
        minLength: minLength(3),
        required
      },

      telefono: {
        requiredIf: requiredIf(function () {
          return !this.cliente.movil
        })
      }
    }
  },

  computed: {
    facturaArgentina () {
      if (!this.cliente.factura_tipo) {
        return null
      }
      return ['FA', 'FB'].includes(this.cliente.factura_tipo)
    },

    facturaEspana () {
      if (!this.cliente.factura_tipo) {
        return null
      }
      return ['FC', 'FS'].includes(this.cliente.factura_tipo)
    },

    facturaTipoComputada () {
      if (this.facturaEspana) {
        return this.necesitaFactura ? 'FC' : 'FS'
      }

      if (this.facturaArgentina) {
        return this.necesitaFactura ? 'FA' : 'FB'
      }

      // Recibo
      return null
    },

    messageErrorCodigoPostal () {
      return this.$validation.getValidationMessage('mEditionBillingMyPaymentsBillingData', this.$v.cliente.cod_postal, 'cod_postal')
    },

    messageErrorDocumentoNum () {
      return this.$validation.getValidationMessage('mEditionBillingMyPaymentsBillingData', this.$v.cliente.documento_numero, 'documento_numero')
    },

    messageErrorFisica () {
      return this.$validation.getValidationMessage('mEditionBillingMyPaymentsBillingData', this.$v.cliente.fisica, 'fisica')
    },

    messageErrorlinea1 () {
      return this.$validation.getValidationMessage('mEditionBillingMyPaymentsBillingData', this.$v.cliente.linea1, 'linea1')
    },

    messageErrorLocalidad () {
      return this.$validation.getValidationMessage('mEditionBillingMyPaymentsBillingData', this.$v.cliente.localidad, 'localidad')
    },

    messageErrorMovil () {
      return this.$validation.getValidationMessage('mEditionBillingMyPaymentsBillingData', this.$v.cliente.movil, 'movil')
    },

    messageErrorPais () {
      return this.$validation.getValidationMessage('mEditionBillingMyPaymentsBillingData', this.$v.cliente.pais, 'pais')
    },

    messageErrorProvincia () {
      return this.$validation.getValidationMessage('mEditionBillingMyPaymentsBillingData', this.$v.cliente.provincia, 'provincia')
    },

    messageErrorRazonSocial () {
      return this.$validation.getValidationMessage('mEditionBillingMyPaymentsBillingData', this.$v.cliente.razon_social, 'razon_social')
    },

    messageErrorTelefono () {
      return this.$validation.getValidationMessage('mEditionBillingMyPaymentsBillingData', this.$v.cliente.telefono, 'telefono')
    },

    messageErrorTipoDoc () {
      return this.$validation.getValidationMessage('mEditionBillingMyPaymentsBillingData', this.$v.cliente.documento_tipo, 'documento_tipo')
    }
  },

  watch: {
    client () {
      if (this.client.datos_personales) {
        this.cliente.fisica = this.client.datos_personales.fisica ? +this.client.datos_personales.fisica : 0
        this.cliente.razon_social = this.client.datos_personales.razon_social ? this.client.datos_personales.razon_social : ''
        this.cliente.movil = this.client.datos_personales.movil ? this.client.datos_personales.movil : this.client.datos_personales.movil
        this.cliente.telefono = this.client.datos_personales.telefono ? this.client.datos_personales.telefono : ''

        if (this.client.datos_personales.domicilio) {
          this.cliente.cod_postal = this.client.datos_personales.domicilio.codigo_postal ? this.client.datos_personales.domicilio.codigo_postal : ''
          this.cliente.linea1 = this.client.datos_personales.domicilio.linea1 ? this.client.datos_personales.domicilio.linea1 : ''
          this.cliente.linea2 = this.client.datos_personales.domicilio.linea2 ? this.client.datos_personales.domicilio.linea2 : ''
          this.cliente.localidad = this.client.datos_personales.domicilio.localidad ? this.client.datos_personales.domicilio.localidad : ''
          this.cliente.pais = this.client.datos_personales.domicilio.provincia.pais.id_pais ? this.client.datos_personales.domicilio.provincia.pais.id_pais : ''
          this.cliente.provincia = this.client.datos_personales.domicilio.provincia.id_provincia ? this.client.datos_personales.domicilio.provincia.id_provincia : ''
        }

        if (this.client.datos_personales.documento) {
          this.cliente.documento_numero = this.client.datos_personales.documento.numero ? this.client.datos_personales.documento.numero : ''
          this.cliente.documento_tipo = this.client.datos_personales.documento.tipo.id_documento_tipo ? this.client.datos_personales.documento.tipo.id_documento_tipo : ''
        }
      }

      this.cliente.email = this.client.email
      this.cliente.fecha_creacion = this.client.fecha_creacion
      this.cliente.factura_tipo = this.client.factura_tipo ? this.client.factura_tipo.value : null
      this.necesitaFactura = this.cliente.factura_tipo
        ? ['FC', 'FA'].includes(this.cliente.factura_tipo)
        : false

      if (this.cliente.pais) {
        this.readParametroDocumentoTipos(this.cliente.pais)
        this.readParametroProvincias(this.cliente.pais)
      } else {
        this.showLoadingState++
        this.showLoadingState++
      }
    },

    'cliente.pais' (newValue, oldValue) {
      if (oldValue !== '' && newValue !== oldValue) {
        this.cliente.provincia = ''
      }
    },

    facturaTipoComputada: {
      handler (nuevoTipo) {
        if (nuevoTipo === 'FA') {
          this.cliente.pais = 3
          this.cliente.documento_tipo = 10
          this.cliente.fisica = 0
        }
      },
      immediate: true
    }
  },

  created () {
    this.readClient()
    this.readParametroPaises()
  },

  methods: {
    readClient () {
      this.$services.read('cliente', 'readCliente', {}, [this.$store.getters.getAcademyData.id])
        .then(response => {
          this.client = response.data
          this.showLoadingState++
        })
        .catch(error => {
          console.log(error)
          this.showLoadingState++
        })
    },

    readParametroDocumentoTipos (idPais) {
      this.$services.read('parametro', 'readParametroDocumentoTipos', {}, [idPais])
        .then(response => {
          this.documentoTipos = response.data
          this.showLoadingState++
        })
        .catch(error => {
          console.log(error)
          this.showLoadingState++
        })
    },

    readParametroPaises () {
      this.$services.read('parametro', 'readParametroPaises')
        .then(response => {
          this.paises = response.data
          this.showLoadingState++
        })
        .catch(error => {
          console.log(error)
          this.showLoadingState++
        })
    },

    readParametroProvincias (idPais) {
      this.$services.read('parametro', 'readParametroProvincias', {}, [idPais])
        .then(response => {
          this.provincias = response.data
          this.showLoadingState++
        })
        .catch(error => {
          console.log(error)
          this.provincias = []
          this.showLoadingState++
        })
    },

    updateClient () {
      this.$v.$touch()
      this.$nextTick(() => this.$validation.focusInputError(this))
      if (!this.buttonPrimary.sending && !this.$v.$invalid) {
        this.cliente.factura_tipo = this.facturaTipoComputada
        this.buttonPrimary.sending = true
        this.$services.update('cliente', 'updateCliente', this.cliente, [this.$store.getters.getAcademyData.id])
          .then(response => {
            this.client = response.data
            this.$alerts.pushAlert('mEditionBillingMyPaymentsBillingData', 'updateUsuario', 'success')
            this.buttonPrimary.sending = false
          })
          .catch(error => {
            console.log(error)
            this.$alerts.pushAlert('mEditionBillingMyPaymentsBillingData', 'updateUsuario', 'error', 'a-alert-danger')
            this.buttonPrimary.sending = false
          })
      }
    }
  }
}
</script>
